// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
} from '@chakra-ui/react';
// Custom Components
import { ItemContent } from 'components/menu/ItemContent';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
// Assets
import navImage from 'assets/img/layout/Navbar.png';
import { MdNotificationsNone } from 'react-icons/md';
import { IoMdMoon, IoMdSunny } from 'react-icons/io';
import { FaEthereum } from 'react-icons/fa';
import navigation from "../../navigation";
import { useNavigate } from 'react-router-dom';
import constants from 'providers/Constants';
import useAuthentication from 'providers/Authentication';
import { SidebarContext } from 'contexts/SidebarContext';
import { useSearch } from 'contexts/SearchContext';
import { FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';

export default function HeaderLinks(props) {
  const { secondary } = props;
  const { colorMode, toggleColorMode } = useColorMode();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { setSearchQuery } = useSearch();

  const [user, setUser] = useState({});
  const [profile, setProfile] = useState({});
  const [developer, setDeveloper] = useState({});
  const [token, setToken] = useState({});

  // Chakra Color Mode
  const navbarIcon = useColorModeValue('gray.400', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  // const textColorBrand = useColorModeValue('brand.700', 'brand.400');
  const ethColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const borderButton = useColorModeValue('secondaryGray.500', 'whiteAlpha.200');

  const authentication = useAuthentication();
  const { toggleSidebar, setToggleSidebar } = useContext(SidebarContext) || {};

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  // const autoDetectColorMode = () => {
  //   const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  //   if (prefersDark) {
  //     setColorMode('dark');
  //   } else {
  //     setColorMode('light');
  //   }
  // };

  // Handle logout
  const handleLogout = () => {
    authentication.logout((error, data) => {
      if (error) {
        constants.showToast(
          "error",
          "FAILED",
          error?.message || "Snap! Logout failed"
        );
      } else {
        constants.showToast(
          "success",
          "SUCCESS",
          "Logged out successfully!"
        );
        navigate('/auth/sign-in');
      }
    });
  };

  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="10px"
      borderRadius="30px"
      boxShadow={shadow}
    >
      {/* Desktop sidebar pin toggle (pin open/auto) */}
      <Button
        onClick={() => setToggleSidebar && setToggleSidebar(!toggleSidebar)}
        variant="ghost"
        color={navbarIcon}
        display={{ base: 'none', xl: 'inline-flex' }}
        alignItems="center"
        justifyContent="center"
        borderRadius="12px"
        me="6px"
        _hover={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        aria-label={toggleSidebar ? t('Unpin (auto-hide) sidebar') : t('Pin sidebar open')}
      >
        <Icon as={toggleSidebar ? FiChevronsRight : FiChevronsLeft} w="18px" h="18px" />
      </Button>
      <SearchBar
        placeholder={t('Search...')}
        onSearch={setSearchQuery}
        mb={() => {
          if (secondary) {
            return { base: '10px', md: 'unset' };
          }
          return 'unset';
        }}
        me="10px"
        borderRadius="30px"
      />
      <Flex
        bg={ethBg}
        display={secondary ? 'flex' : 'none'}
        borderRadius="30px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      >
        <Flex
          align="center"
          justify="center"
          bg={ethBox}
          h="29px"
          w="29px"
          borderRadius="30px"
          me="7px"
        >
          <Icon color={ethColor} w="9px" h="14px" as={FaEthereum} />
        </Flex>
        <Text
          w="max-content"
          color={ethColor}
          fontSize="sm"
          fontWeight="700"
          me="6px"
        >
          1,924
          <Text as="span" display={{ base: 'none', md: 'unset' }}>
            {' '}
            ETH
          </Text>
        </Text>
      </Flex>
      <SidebarResponsive routes={navigation} />
      <Menu>
        <MenuButton p="0px">
          <Icon
            mt="6px"
            as={MdNotificationsNone}
            color={navbarIcon}
            w="18px"
            h="18px"
            me="10px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="20px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          me={{ base: '30px', md: 'unset' }}
          minW={{ base: 'unset', md: '400px', xl: '450px' }}
          maxW={{ base: '360px', md: 'unset' }}
        >
          <Flex w="100%" mb="20px">
            <Text fontSize="md" fontWeight="600" color={textColor}>
              {t('Changelog')}
            </Text>
            {/* <Text
              fontSize="sm"
              fontWeight="500"
              color={textColorBrand}
              ms="auto"
              cursor="pointer"
            >
              Mark all read
            </Text> */}
          </Flex>
          <Flex flexDirection="column">
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              px="0"
              borderRadius="8px"
              mb="10px"
            >
              <ItemContent
                info={t("VISA & MasterCard now available!")}
                message={t("You can now generate VISA & MasterCard cards for your users. Check our API documentation for more information.")}
              />
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>

      <Menu>
        {/* <MenuButton p="0px">
          <Icon
            mt="6px"
            as={MdInfoOutline}
            color={navbarIcon}
            w="18px"
            h="18px"
            me="10px"
          />
        </MenuButton> */}
        <MenuList
          boxShadow={shadow}
          p="20px"
          me={{ base: '30px', md: 'unset' }}
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          minW={{ base: 'unset' }}
          maxW={{ base: '360px', md: 'unset' }}
        >
          <Image src={navImage} borderRadius="16px" mb="28px" />
          <Flex flexDirection="column">
            <Link w="100%" href="https://horizon-ui.com/pro">
              <Button w="100%" h="44px" mb="10px" variant="brand">
                Buy Horizon UI PRO
              </Button>
            </Link>
            <Link
              w="100%"
              href="https://horizon-ui.com/documentation/docs/introduction"
            >
              <Button
                w="100%"
                h="44px"
                mb="10px"
                border="1px solid"
                bg="transparent"
                borderColor={borderButton}
              >
                See Documentation
              </Button>
            </Link>
            <Link
              w="100%"
              href="https://github.com/horizon-ui/horizon-ui-chakra-ts"
            >
              <Button
                w="100%"
                h="44px"
                variant="no-hover"
                color={textColor}
                bg="transparent"
              >
                Try Horizon Free
              </Button>
            </Link>
          </Flex>
        </MenuList>
      </Menu>

      <Button
        variant="no-hover"
        bg="transparent"
        p="0px"
        minW="unset"
        minH="unset"
        h="18px"
        w="max-content"
        onClick={toggleColorMode}
      >
        <Icon
          me="10px"
          h="18px"
          w="18px"
          color={navbarIcon}
          as={colorMode === 'light' ? IoMdMoon : IoMdSunny}
        />
      </Button>

      {/* Language Switcher */}
      <Menu>
        <MenuButton as={Button} variant="ghost" color={navbarIcon} me="6px" px="8px">
          <Text fontSize="sm" fontWeight="600" color={textColor} textTransform="uppercase">
            {i18n.language === 'fr' ? 'FR' : 'EN'}
          </Text>
        </MenuButton>
        <MenuList boxShadow={shadow} p="10px" borderRadius="12px" bg={menuBg} border="none">
          <MenuItem onClick={() => { i18n.changeLanguage('en'); if (typeof window !== 'undefined') window.localStorage.setItem('app.lang', 'en'); }}>
            {t('English')} (EN)
          </MenuItem>
          {
            constants.getCurrentEnvironment() == 'SANDBOX' ? (
              <MenuItem onClick={() => { i18n.changeLanguage('fr'); if (typeof window !== 'undefined') window.localStorage.setItem('app.lang', 'fr'); }}>
                {t('French')} (FR)
              </MenuItem>
            ) : null
          }
        </MenuList>
      </Menu>
      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            color="white"
            name={user?.first_name || 'User'}
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              {`👋 ${t('Hey, {{name}}', { name: user?.first_name || 'User' })}`}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              onClick={handleLogout}
              cursor="pointer"
            >
              <Text fontSize="sm">{t('Log out')}</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );

  // Get user
  async function getUser() {
    authentication.getUser((error, data) => {
      if (error) {
        constants.showToast(
          "error",
          "FAILED",
          error?.message || "Snap! Something went wrong, Try again"
        );
      } else {
        setUser(data?.user || {});
        setProfile(data?.profile || {});
        setDeveloper(data?.developer || {});
        setToken(data?.token || {});
      }
    });
  }
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
